import { AppBar, Box, Tab, Tabs, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { getDataInLocalstorage } from "common/method/getDataInLocalstorage";
import PropTypes from "prop-types";
import { useEffect, useMemo, useState } from "react";
import { Redirect, Route, useLocation } from "react-router-dom";
import { useMouse } from "rooks";
import { FadeInt2Div, FadeInt3Div } from "styledComponents/animation";
import Btns from "../layout2/btns";
import ForgotPassChange from "./changePass";
import ConfirmOtp from "./confirmOtp.js";
import ForgotPassword from "./forgetPass";
import ForgetSendAlert from "./forgetSendAlert";
import HeaderLogin from "./header";
import LoginPanel from "./loginPanel";
import LoginPass from "./loginPass";
import Register from "./register";
import { useTheme } from "@mui/material/styles";
import BerelianHeader from "./berelianHeader";
import BerelianFooter from "./berelianFooter";

const query_national_member_id =
  new URLSearchParams(window.location.search).get("member_national_id") ?? "";
function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography component={"div"}>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `scrollable-auto-tab-${index}`,
    "aria-controls": `scrollable-auto-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  root: {
    // flexGrow: 1,
    // display:"flex",
    // justifyContent:"center",
    width: "100%",

    // "@media (max-width:1200px)": {
    //   padding: "0 !important",
    // },
    fontFamily: "IRANSansWeb_Farsi !important",
  },
  tabBar: {
    backgroundColor: "#fff !important",
    boxShadow: "none !important",
  },
  tabBarLable: {
    color: theme.palette.text.primary,
    display: "flex",
    justifyContent: "center",
  },
  tabPanel: {
    fontWeight: 900,
    fontSize: "14px !important",
    "@media (min-width:991px) and (max-width:1400px)": {
      minWidth: "101px !important",
    },
  },
  paddingNone: {
    padding: "0 !important",
    "& > div": {
      padding: "0",
    },
  },
  bold: {
    fontWeight: 600,
    fontSize: 15,
  },
  GreenBold: {
    fontSize: 15,
    fontWeight: 600,
    color: "#099C55",
  },
  box: {
    width: 400,
    "@media (min-width:100px) and (max-width:350px)": {
      width: 290,
    },
    "@media (min-width:351px) and (max-width:420px)": {
      width: 350,
    },
  },
}));
function useQuery() {
  const { search } = useLocation();

  return useMemo(() => new URLSearchParams(search), [search]);
}

const Login = () => {
  const theme = useTheme();
  const location = useLocation();
  let query = useQuery();
  const [utmQuery, setUtmQuery] = useState(undefined);
  useEffect(() => {
    setUtmQuery(query.get("id"));
  }, [query]);

  const classes = useStyles();

  const [value, setValue] = useState(0);
  const [flagLogin, setflagLogin] = useState(0);
  const info = useMouse();

  const [userInfo, setUserInfo] = useState({});
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const user = getDataInLocalstorage();
  let token = user?.token;
  let member_id = user?.member_id;

  if (token?.authToken && member_id && location.pathname === "/auth") {
    return <Redirect from="/" to="/offline-order" />;
  }

  return (
    <>
      <BerelianHeader />

      <Box
        sx={{
          width: "100%",
          display: "flex",
          justifyContent: "center",
          pb: { xs: 3, md: 3 },
          pt: 2,
        }}
      >
        <Box
          sx={{
            maxWidth: "100%",
            px: { xs: 2, sm: 0 },
          }}
        >
          <Box
            className={`${classes.box} bg-white rounded-lg flex flex-row-reverse justify-center px-4 md:px-8`}
            sx={{ boxShadow: "0px 10px 35px rgba(0,0,0,0.08)" }}
          >
            {flagLogin !== 5 && (
              <div className={`${classes.root}`}>
                {flagLogin === 0 && (
                  <FadeInt2Div>
                    <LoginPanel
                      setflagLogin={setflagLogin}
                      flagLogin={flagLogin}
                      setUserInfo={setUserInfo}
                      query_national_member_id={query_national_member_id}
                    />
                  </FadeInt2Div>
                )}

                {flagLogin === 2 && (
                  <FadeInt3Div>
                    <ConfirmOtp
                      setflagLogin={setflagLogin}
                      userInfo={userInfo}
                    />
                  </FadeInt3Div>
                )}
              </div>
            )}
          </Box>
        </Box>
      </Box>

      <BerelianFooter />

      {token && member_id && <Redirect exact from="/" to="/offline-order" />}
    </>
  );
};

export default Login;
